import React from "react";
import { useFavourites } from "@/contexts/FavouritesProvider";
import { useAuth } from "@/contexts/AuthProvider";
import PropertyCard from "@/components/PropertyCard";
import BrandHeading from "@/components/brand/BrandHeading";
import BrandLabel from "@/components/brand/BrandLabel";
import BrandButton from "@/components/brand/BrandButton";
import BrandCard from "@/components/brand/BrandCard";

const Favourites = () => {
  const { items, loading } = useFavourites();
  const { user } = useAuth();

  if (!user) {
    return (
      <div className="container-rail py-16 md:py-24" data-testid="favourites-signed-out">
        <BrandLabel withRule>Saved across the portfolio</BrandLabel>
        <BrandHeading level={1} className="mt-4">Sign in to keep favourites</BrandHeading>
        <p className="mt-4 max-w-[52ch] text-muted-foreground">Save houses, residences and stays across the three brands and keep them here for later.</p>
        <div className="mt-8">
          <BrandButton to="/auth/sign-in" data-testid="signin-cta">Sign in</BrandButton>
        </div>
      </div>
    );
  }

  return (
    <div className="container-rail py-10 md:py-16" data-testid="favourites-page">
      <BrandLabel withRule>Across the portfolio</BrandLabel>
      <BrandHeading level={1} className="mt-3">Your favourites</BrandHeading>
      <p className="mt-3 max-w-[58ch] text-muted-foreground">Saved houses, retreats and residences from the GMH portfolio.</p>

      <div className="mt-10">
        {loading ? <p>Loading…</p> : items.length === 0 ? (
          <BrandCard className="p-10 text-center text-muted-foreground" data-testid="no-favourites">You haven't saved anything yet.</BrandCard>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {items.map((it) => (<PropertyCard key={it.id} item={{ ...it, type: it.bedrooms ? "residence" : "property" }} showBrandBadge />))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Favourites;
